import { render, staticRenderFns } from "./mobanlist.vue?vue&type=template&id=267a8bb4&scoped=true"
import script from "./mobanlist.vue?vue&type=script&lang=js"
export * from "./mobanlist.vue?vue&type=script&lang=js"
import style0 from "./mobanlist.vue?vue&type=style&index=0&id=267a8bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a8bb4",
  null
  
)

export default component.exports